// extracted by mini-css-extract-plugin
export default {"wrapper":"Edit_wrapper__dAo05","col":"Edit_col__XiAq7"};